import React, { useState } from 'react';
import { Button, HStack, Modal, ModalBody, ModalContent, ModalOverlay, useToast, } from '@chakra-ui/react';
import { pluck, uniq } from 'ramda';
import { PermissionModalContent } from '../PermissionModalContent/PermissionModalContent';
import { localise, templateReplace } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import { useUpdateOfficerInvite } from '../../../services/api/generated/client';
import { RenderIf } from '../RenderIf/RenderIf';
import { ErrorAwareAlertBox } from '../ErrorAwareAlertBox/ErrorAwareAlertBox';
import StandardModalHeader from '../Modal/StandardModalHeader';
export const InvitedUsersTablePermissionsModal = (props) => {
    const toast = useToast();
    const tokens = useTokens();
    const [stagedRoles, setStagedRoles] = useState(pluck('id', props.invite.roles));
    const { mutate, isPending, isError, error } = useUpdateOfficerInvite();
    const onAddRole = (role) => {
        setStagedRoles(uniq([...stagedRoles, role]));
    };
    const onRemoveRole = (role) => {
        setStagedRoles(stagedRoles.filter((r) => r !== role));
    };
    const onSubmit = () => {
        mutate({
            id: props.invite.id,
            data: {
                role_ids: stagedRoles,
            },
        }, {
            onSuccess: () => {
                props.onUpdated();
                toast({
                    status: 'success',
                    title: localise('PERMISSIONS_UPDATED'),
                    description: localise('PERMISSIONS_UPDATED_BLURB'),
                });
            },
        });
    };
    return (React.createElement(Modal, { variant: "primary", isOpen: true, onClose: props.onClose },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, { "data-testid": "invited-users-table-permissions-modal" },
            React.createElement(StandardModalHeader, { title: templateReplace(localise('ASSIGN_PERMISSIONS_TO'), {
                    name: props.invite.email,
                }), closeLabel: localise('CLOSE_INVITE_TEAM_MODAL'), closeButtonTestId: "invitation-permissions-modal__close-icon" }),
            React.createElement(RenderIf, { condition: isError },
                React.createElement(ErrorAwareAlertBox, { error: error })),
            React.createElement(ModalBody, null,
                React.createElement(PermissionModalContent, { checkedRoles: stagedRoles, onAddRole: onAddRole, onRemoveRole: onRemoveRole }),
                React.createElement(HStack, { mt: 4, width: "100%", justifyContent: "end", gap: tokens.Spacing06 },
                    React.createElement(Button, { variant: "secondary", onClick: props.onClose, "data-testid": "confirmation-modal__close" }, localise('CANCEL')),
                    React.createElement(Button, { variant: "primary", "data-testid": "invitation-permissions__confirm", onClick: onSubmit, isLoading: isPending }, localise('CONFIRM')))))));
};
